export default __webpack_public_path__ + "static/media/solar-panel.14fe49ed.png";